import * as R from 'ramda'
import Raven from 'raven-js'
import createRavenMiddleware from 'raven-for-redux'
import { SET_LANGUAGE } from 'redux-polyglot'
import { isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from './actions'

// type FilterAction = Action => {}
const filterAction = R.pipe(
  R.when(
    isActionType(SET_LANGUAGE),
    R.assocPath(['payload', 'phrases'], 'stripped')
  ),
  R.when(
    isActionType(Actions.resources.RESOURCE_FETCHED),
    R.assocPath(['payload', 'response'], 'stripped')
  ),
  R.when(
    isActionType(Actions.member.MEMBER_INFO_FETCHED),
    R.assocPath(['payload', 'response', 'member'], 'hidden')
  ),
  R.dissoc('type')
)

// type BreadcrumbDataFromAction = Action => {}
const breadcrumbDataFromAction = filterAction

// type ActionTransformer = Action => {}
const actionTransformer = filterAction

// type StateTransformer = State => {}
const stateTransformer = R.pipe(
  R.assoc('polyglot', 'stripped'),
  R.assocPath(['member', 'memberInfo'], 'hidden')
)

export default (
  __RAVEN__
    ? createRavenMiddleware(Raven, {
      actionTransformer,
      breadcrumbDataFromAction,
      stateTransformer
    })
    : null
)
